import React, { useState } from "react";
import CustomScroll from "react-custom-scroll";

const DropdownFilter = ({ search, searchPlaceholder, values, setValue }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredValues = search
    ? [...values.keys()].filter(key =>
        values.get(key).toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [...values.keys()];

  return (
    <CustomScroll>
      <div className="filter-dropdown-inner">
        {search && (
          <input
            className="filter-dropdown__input"
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder={searchPlaceholder}
          />
        )}
        {filteredValues.map(key => (
          <div
            key={key}
            className={"filter-dropdown__item resource-" + key}
            onClick={() => setValue(key)}
          >
            {values.get(key)}
          </div>
        ))}
        {search && filteredValues.length === 0 && (
          <div className="filter-dropdown__item">Ничего не найдено</div>
        )}
      </div>
    </CustomScroll>
  );
};

export default DropdownFilter;
